export default __webpack_public_path__ + "static/media/target1.7b52a082.svg";